"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCompany = exports.capitalize = exports.concatURI = exports.split = void 0;
/**
 * str を delimiter で split したうえで、 trim して空文字列を除去する
 * @param  str       [description]
 * @param  delimiter [description]
 * @return           [description]
 */
function split(str, delimiter) {
    return (str || "")
        .split(delimiter)
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return !!s; });
}
exports.split = split;
/**
 * 適宜 / を調整しながらURLを結合する
 * @param  fracts URI断片
 * @return        [description]
 */
function concatURI() {
    var fracts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fracts[_i] = arguments[_i];
    }
    if (fracts.length === 0) {
        return "";
    }
    var head = fracts[0];
    var tail = concatURI.apply(void 0, __spreadArray([], __read(fracts.slice(1)), false));
    if (tail === "") {
        return head;
    }
    var isHS = head.endsWith("/");
    var isTS = tail.startsWith("/");
    if (isHS && isTS) {
        return head + tail.substr(1);
    }
    if (!isHS && !isTS) {
        return head + "/" + tail;
    }
    return head + tail;
}
exports.concatURI = concatURI;
var capitalize = function (str) {
    if (!str) {
        return "";
    }
    return str[0].toUpperCase() + str.substr(1);
};
exports.capitalize = capitalize;
var dictionary = {
    株: "株式会社",
    有: "有限会社",
    有限: "有限会社",
    有組: "有限責任組合",
    特非: "特定非営利活動法人",
    特許: "特許業務法人",
    合: "合同会社",
    同: "合同会社",
    名: "合名会社",
    資: "合資会社",
    一社: "一般社団法人",
    一般社団: "一般社団法人",
    一財: "一般財団法人",
    財: "一般財団法人",
    一般財団: "一般財団法人",
    公財: "公益財団法人",
    公益財団: "公益財団法人",
    公社: "公益社団法人",
    公益社団: "公益社団法人",
    社: "一般社団法人",
    大: "国立大学法人",
    学: "学校法人",
    学校法人: "学校法人",
    弁: "弁護士法人",
    医: "医療法人",
    協組: "協同組合",
    農: "農業協同組合",
    漁: "漁業協同組合",
    協: "協同組合",
    組: "組合",
    商: "商工会",
    連: "連合会",
    団: "団体",
    公: "公益法人",
    外: "外国会社",
    宗: "宗教法人",
    中: "有限責任中間法人",
    国研: "国立研究開発法人",
    地独: "地方独立行政法人",
    独: "独立行政法人",
    相: "相互会社",
    研: "国立研究開発法人",
    社福: "社会福祉法人",
    医福: "医療福祉法人",
    福: "社会福祉法人",
    税: "税理士法人",
    行: "行政書士法人",
    弁理士法人: "弁理士法人",
    大学共同利用機関法人: "大学共同利用機関法人",
    生協: "生活協同組合",
    公立大学法人: "公立大学法人",
    協業組合: "協業組合",
    ＮＰＯ法人: "特定非営利活動法人",
    NPO法人: "特定非営利活動法人",
};
var brackets = [
    ["(", ")"],
    ["（", "）"],
    ["[", "]"],
    ["［", "］"],
    ["<", ">"],
    ["＜", "＞"],
    ["【", "】"],
    ["「", "」"],
    ["{", "}"],
    ["｛", "｝"],
    ["〔", "〕"],
    ["『", "』"],
    ["〈", "〉"],
    ["*", "*"],
    ["＊", "＊"],
];
var normalizeCompany = function (company) {
    return brackets
        .reduce(function (memo, _a) {
        var _b = __read(_a, 2), s = _b[0], e = _b[1];
        return memo.replace(new RegExp("\\".concat(s, "[^").concat(e, "]+\\").concat(e)), "");
    }, Object.keys(dictionary).reduce(function (memo, key) {
        return memo
            .replace(new RegExp("\\(".concat(key, "\\)|\uFF08").concat(key, "\uFF09|\\(").concat(dictionary[key], "\\)|\uFF08").concat(dictionary[key], "\uFF09")), dictionary[key])
            .replace(new RegExp("^(".concat(key, "\\))|(").concat(key, "\uFF09)")), dictionary[key])
            .replace(new RegExp("(\\(".concat(key, ")|(\\\uFF08").concat(key, ")$")), dictionary[key]);
    }, company
        .replace(/[①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳㉑㉒㉓㉔㉕㉖㉗㉘㉙㉚㉛㉜㉝㉞㉟㊱㊲㊳㊴㊵㊶㊷㊸㊹㊺㊻㊼㊽㊾㊿🄋➀➁➂➃➄➅➆➇➈➉⓿❶❷❸❹❺❻❼❽❾❿⓫⓬⓭⓮⓯⓰⓱⓲⓳⓴🄌➊➋➌➍➎➏➐➑➒➓⓵⓶⓷⓸⓹⓺⓻⓼⓽⓾]/gu, "")
        .normalize("NFKC")
        .replace(/㈱/, "株式会社")
        .replace(/㈲/, "有限会社")
        .replace(/(\d{6,7})?([\s_]+)?(\d+-\d+)?/g, "")
        .replace(/\d{1,2}月分?/g, "")
        .replace(/\d{1,2}\/\d{1,2}/g, "")
        .trim()))
        .replace(/^(.+株式会社)(.+)$/, "$1")
        .replace(/(.+有限会社)(.+)/, "$1")
        .replace(/[:()]/gu, "");
};
exports.normalizeCompany = normalizeCompany;
